<div class="container-fluid main-Cntn-Fluid">
  <div class="row main-Row">
    <div class="col-md-8 col-12 col-sm-12 col-lg-8 col-xl-8 main-Col-Span">
      <div class="container-fluid tabs-Section-Container">
        <div class="row tabs-Row-Flex">
          <div class="selected-Tab-Display-Div tab-Selec-Div col-lg-7 col-md-7 col-sm-7 col-xl-7 ">
            <span class="tab-Selected">{{tabSelected |cxTranslate}}</span>
          </div>
          <div class="multiple-Tab-Div large-Device-Tabs col-lg-5 col-xl-5 col-md-5 col-sm-5">
            <ul class="nav nav-tabs">
              <li
                class="nav-item p-0"
                [ngClass]="{ 'nav-Item-Border': tabSelected == 'profile.userheading' }"
              >
                <p
                  (click)="tabNavigation('profile.userheading', 'User')"
                  class="fontSize-Tab-Name"
                  [ngClass]="{ 'tab-Name': tabSelected == 'profile.userheading' }"
                >
                {{'profile.user'|cxTranslate}}
                </p>
              </li>
              <li
                class="nav-item"
                [ngClass]="{
                  'nav-Item-Border': tabSelected == 'profile.accountheading'
                }"
              >
                <p
                  class="fontSize-Tab-Name"
                  (click)="tabNavigation('profile.accountheading', 'Account')"
                  [ngClass]="{
                    'tab-Name': tabSelected == 'profile.accountheading'
                  }"
                >
                {{'profile.account'|cxTranslate}}
                </p>
              </li>
              <li
                class="nav-item"
                [ngClass]="{
                  'nav-Item-Border': tabSelected == 'profile.paymentheading'
                }"
              >
                <p
                  class="fontSize-Tab-Name paymentTab"
                  (click)="tabNavigation('profile.paymentheading', 'Payment')"
                  [ngClass]="{ 'tab-Name': tabSelected == 'profile.paymentheading' }"
                >
                {{'profile.payment'|cxTranslate}}
                </p>
              </li>
            </ul>
          </div>

          <div class="col-sm-12 col-12 col-xs-12 small-Device-Tabs">
            <ng-select 
            class="small-Tab-Select"
            [items]="tabDataArray" bindLabel="key" 
            bindValue="value" [multiple]="false" name="selecTabVal" [clearable]="false"
            placeholder=""
            (ngModelChange)="tabNavigationDropDown()"
              [(ngModel)]="tabSelected">
            </ng-select>
          
          </div>
        </div>
      </div>
      <div class="tab-contents">
        <div *ngIf="tabSelected === 'profile.userheading'">
          <app-user></app-user>
        </div>
        <div *ngIf="tabSelected === 'profile.accountheading'">
          <app-account></app-account>
        </div>
        <div *ngIf="tabSelected === 'profile.paymentheading'">
          <app-payment></app-payment>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-12 col-sm-12 col-lg-4 col-xl-4 myAccount-Col-Span">
      <app-my-account></app-my-account>
    </div>
  </div>
</div>


